import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Pagination } from "react-bootstrap";
import { useAtomValue } from 'jotai';
import { devModeAtom } from '../../atoms';
import ConfirmModal from "../ConfirmModal";
import "./player.css";

function Player({player, games, getGames, deleteGame, undeleteGame, destroyGame, copyGame}) {

    const navigate = useNavigate();
    const [pendingDeleteGame, setPendingDeleteGame] = useState(null);
    const [pendingDestroyGame, setPendingDestroyGame] = useState(null);
    const [finishedGamesPage, setFinishedGamesPage] = useState(0);
    const devMode = useAtomValue(devModeAtom);

    const isCreatorOf = (game) => {
        if (game.creatorId != null) return game.creatorId === player.id;
        if (!game.gamePlayers || game.gamePlayers.length === 0) return false;
        const creatorGp = game.gamePlayers.reduce((min, gp) => gp.id < min.id ? gp : min);
        return creatorGp.playerId === player.id;
    };

    const handleDeleteConfirm = () => {
        deleteGame(pendingDeleteGame.id);
        setPendingDeleteGame(null);
    };

    const handleDestroyConfirm = () => {
        destroyGame(pendingDestroyGame.id);
        setPendingDestroyGame(null);
    };

    const lastActivitySummary = (game) => {
        if (!game.currentPlayer && !game.currentRound) {
            return "Game has not started yet";
        }
        const playerCount = game.gamePlayers.length;
        const lastPlayerIndex = (game.currentPlayer - 1 + playerCount) % playerCount;
        return game.gamePlayers[lastPlayerIndex]?.lastWord || "No activity yet";
    }

    const goToGame = (gameId) => {
        navigate(`/game/${gameId}`, {replace: true});
    }
    
    useEffect(() => {
        console.log("GET GAMES FROM PLAYER COMPONENT")
        getGames();
    }, [])

    let activeGames = games.filter(game => game.status === "active");
    let deletedGames = games.filter(game => game.status === "deleted");
    const PAGE_SIZE = 20;
    const finishedGames = games
        .filter(g => g.status === "finished")
        .sort((a, b) => new Date(b.lastActivity) - new Date(a.lastActivity));
    const finishedPage = finishedGames.slice(finishedGamesPage * PAGE_SIZE, (finishedGamesPage + 1) * PAGE_SIZE);
    const finishedPageCount = Math.ceil(finishedGames.length / PAGE_SIZE);

    return (
        <>
            <div className="d-flex justify-content-between mb-1">
                <h3>Active Games</h3>
                <Link className="btn btn-success" to="/newGame">New Game</Link>
            </div>
           
            <div className="gamesList">
                <div className="gamesListHeader row d-md-flex d-none">
                    <div className="gamesListName col-md-2 order-md-0">Game</div>
                    <div className="gamesListRound col-md-1 order-md-1">Round</div>
                    <div className="gamesListScore col-md-3 order-md-2">Scores</div>
                    <div className="gamesListLast col-md-3 order-md-3">Last Activity</div>
                    <div className="col-md-3 order-md-4"></div>
                </div>
                {activeGames.length 
                ? activeGames.map((g, i) => (
                    <div onClick={() => goToGame(g.id)} key={`game${i}`} className={`gamesListGame row ${g.gamePlayers.find(gp => gp.playOrder === g.currentPlayer)?.playerId === player.id ? "yourTurn" : ""}`}>
                        <div  className="gamesListName col-md-2 order-md-0 col-12">{g.name} <span className="d-md-none"> - Round {g.currentRound + 1}</span></div>
                        <div className="gamesListRound col-md-1 order-md-1 d-none d-md-block">{g.currentRound + 1}</div>
                    <div className="d-flex flex-wrap gamesListScore col-md-3 order-md-2 col-12">
                        {[...g.gamePlayers].sort((a, b) => a.playOrder - b.playOrder).map((p, i) => (
                            <div key={`player${i}`} style={{fontWeight: p.playOrder === g.currentPlayer ? "bold" : "normal",marginRight: i < g.gamePlayers.length - 1 ? ".25em" : 0}}>{p.name}: {p.score}{i < g.gamePlayers.length - 1 ? ",": ""}</div>
                        ))}
                    </div>
                    <div className="gamesListLast col-md-3 order-md-3 col-12">{lastActivitySummary(g)}</div>
                    <div className="col-md-3 order-md-4 col-12 d-flex gap-2">
                        {isCreatorOf(g) && (
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={(e) => { e.stopPropagation(); setPendingDeleteGame(g); }}
                            >
                                Delete
                            </button>
                        )}
                        {devMode && isCreatorOf(g) && (
                            <button
                                className="btn btn-secondary btn-sm"
                                onClick={(e) => { e.stopPropagation(); copyGame(g.id); }}
                            >
                                Copy
                            </button>
                        )}
                    </div>
                    </div>
                ))
                : <div>NO Active Games</div>
            }

            </div>

            {finishedGames.length > 0 && (
                <>
                    <div className="d-flex justify-content-between mb-1 mt-4">
                        <h3>Finished Games</h3>
                    </div>
                    <div className="gamesList">
                        <div className="gamesListHeader row d-md-flex d-none">
                            <div className="gamesListName col-md-2 order-md-0">Game</div>
                            <div className="gamesListRound col-md-1 order-md-1 d-none d-md-block">Round</div>
                            <div className="gamesListScore col-md-3 order-md-2">Scores</div>
                            <div className="gamesListLast col-md-3 order-md-3">Finished</div>
                            <div className="col-md-3 order-md-4"></div>
                        </div>
                        {finishedPage.map((g, i) => (
                            <div onClick={() => goToGame(g.id)} key={`finished${i}`} className="gamesListGame row" style={{cursor: "pointer"}}>
                                <div className="gamesListName col-md-2 order-md-0 col-12">{g.name} <span className="d-md-none"> - Round {g.currentRound + 1}</span></div>
                                <div className="gamesListRound col-md-1 order-md-1 d-none d-md-block">{g.currentRound + 1}</div>
                                <div className="d-flex flex-wrap gamesListScore col-md-3 order-md-2 col-12">
                                    {[...g.gamePlayers].sort((a, b) => a.playOrder - b.playOrder).map((p, j) => (
                                        <div key={`fp${j}`} style={{marginRight: j < g.gamePlayers.length - 1 ? ".25em" : 0}}>{p.name}: {p.score}{j < g.gamePlayers.length - 1 ? "," : ""}</div>
                                    ))}
                                </div>
                                <div className="gamesListLast col-md-3 order-md-3 col-12">
                                    {g.lastActivity ? new Date(g.lastActivity).toLocaleDateString() : ""}
                                </div>
                                <div className="col-md-3 order-md-4"></div>
                            </div>
                        ))}
                    </div>
                    {finishedGames.length > PAGE_SIZE && (
                        <Pagination className="mt-2 justify-content-center">
                            <Pagination.First onClick={() => setFinishedGamesPage(0)} disabled={finishedGamesPage === 0} />
                            <Pagination.Prev onClick={() => setFinishedGamesPage(p => Math.max(0, p - 1))} disabled={finishedGamesPage === 0} />
                            {Array.from({ length: finishedPageCount }, (_, n) => (
                                <Pagination.Item key={n} active={n === finishedGamesPage} onClick={() => setFinishedGamesPage(n)}>{n + 1}</Pagination.Item>
                            ))}
                            <Pagination.Next onClick={() => setFinishedGamesPage(p => Math.min(finishedPageCount - 1, p + 1))} disabled={finishedGamesPage === finishedPageCount - 1} />
                            <Pagination.Last onClick={() => setFinishedGamesPage(finishedPageCount - 1)} disabled={finishedGamesPage === finishedPageCount - 1} />
                        </Pagination>
                    )}
                </>
            )}

            {deletedGames.length > 0 && (
                <>
                    <div className="d-flex justify-content-between mb-1 mt-4">
                        <h3>Deleted Games</h3>
                    </div>
                    <div className="gamesList">
                        <div className="gamesListHeader row d-md-flex d-none">
                            <div className="gamesListName col-md-2 order-md-0">Game</div>
                            <div className="gamesListRound col-md-1 order-md-1">Round</div>
                            <div className="gamesListScore col-md-3 order-md-2">Scores</div>
                            <div className="gamesListLast col-md-3 order-md-3">Last Activity</div>
                            <div className="col-md-3 order-md-4"></div>
                        </div>
                        {deletedGames.map((g, i) => (
                            <div key={`deleted${i}`} className="gamesListGame row">
                                <div className="gamesListName col-md-2 order-md-0 col-12">{g.name} <span className="d-md-none"> - Round {g.currentRound + 1}</span></div>
                                <div className="gamesListRound col-md-1 order-md-1 d-none d-md-block">{g.currentRound + 1}</div>
                                <div className="d-flex flex-wrap gamesListScore col-md-3 order-md-2 col-12">
                                    {g.gamePlayers.map((p, i) => (
                                        <div key={`dp${i}`} style={{marginRight: i < g.gamePlayers.length - 1 ? ".25em" : 0}}>{p.name}: {p.score}{i < g.gamePlayers.length - 1 ? "," : ""}</div>
                                    ))}
                                </div>
                                <div className="gamesListLast col-md-3 order-md-3 col-12">{lastActivitySummary(g)}</div>
                                <div className="col-md-3 order-md-4 col-12 d-flex gap-2">
                                    {isCreatorOf(g) && (
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => undeleteGame(g.id)}
                                        >
                                            Undelete
                                        </button>
                                    )}
                                    {isCreatorOf(g) && (
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => setPendingDestroyGame(g)}
                                        >
                                            Destroy
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}

            <ConfirmModal
                show={pendingDeleteGame !== null}
                title="Delete Game"
                body={`Are you sure you want to delete "${pendingDeleteGame?.name}"?`}
                confirmLabel="Delete"
                confirmVariant="danger"
                onConfirm={handleDeleteConfirm}
                onCancel={() => setPendingDeleteGame(null)}
            />

            <ConfirmModal
                show={pendingDestroyGame !== null}
                title="Destroy Game"
                body={`Are you sure you want to permanently destroy "${pendingDestroyGame?.name}"? This action is permanent and cannot be undone.`}
                confirmLabel="Destroy"
                confirmVariant="danger"
                onConfirm={handleDestroyConfirm}
                onCancel={() => setPendingDestroyGame(null)}
            />
        </>
    )
}

export default Player;